import React from "react";
import Title from "../components/Title";
import { assets } from "../assets/assets";
import NewsletterBox from "../components/NewsletterBox";
import { Helmet } from "react-helmet";

const Contact = () => {
  return (
    <div>
      <Helmet>
        <title>Contact Sahla Curtain Center | Curtain Store in Kerala</title>
        <meta name="description" content="Contact Sahla Curtain Center for premium curtains, expert installation, and customer support in Kerala. Visit our store, call, or email us for all your curtain needs." />
        <meta name="keywords" content="contact Sahla Curtain Center, curtain store Kerala, curtain installation, customer support, Kalpakanchery, phone, email, address" />
        <link rel="canonical" href="https://sccstore.com/contact" />
        {/* Open Graph */}
        <meta property="og:title" content="Contact Sahla Curtain Center | Curtain Store in Kerala" />
        <meta property="og:description" content="Get in touch with Sahla Curtain Center for premium curtains, installation, and support. Visit, call, or email us in Kalpakanchery, Kerala." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://sccstore.com/contact" />
        <meta property="og:image" content="https://sccstore.com/preview.jpg" />
        <meta property="og:site_name" content="Sahla Curtain Center" />
        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Contact Sahla Curtain Center | Curtain Store in Kerala" />
        <meta name="twitter:description" content="Contact Sahla Curtain Center for premium curtains, expert installation, and customer support in Kerala." />
        <meta name="twitter:image" content="https://sccstore.com/preview.jpg" />
        <meta name="twitter:site" content="@sccstore" />
        {/* Social Profiles */}
        <meta property="og:see_also" content="https://www.instagram.com/sahlacurtaincenter/" />
        <meta property="og:see_also" content="https://www.facebook.com/people/Sahla-Curtain-Center/61565451845405/" />
        <meta property="og:see_also" content="https://www.youtube.com/@sahlacurtaincenter" />
        {/* JSON-LD Structured Data */}
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "ContactPage",
            "name": "Contact Sahla Curtain Center",
            "description": "Contact Sahla Curtain Center for premium curtains, expert installation, and customer support in Kerala.",
            "url": "https://sccstore.com/contact",
            "image": "https://sccstore.com/preview.jpg",
            "publisher": {
              "@type": "Organization",
              "name": "Sahla Curtain Center",
              "logo": {
                "@type": "ImageObject",
                "url": "https://sccstore.com/favicon.png"
              },
              "sameAs": [
                "https://www.instagram.com/sahlacurtaincenter/",
                "https://www.facebook.com/people/Sahla-Curtain-Center/61565451845405/",
                "https://www.youtube.com/@sahlacurtaincenter"
              ]
            },
            "contactPoint": {
              "@type": "ContactPoint",
              "telephone": "+91-9895846494",
              "contactType": "customer service",
              "email": "about@sccstore.com"
            },
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "Mambara Rd, Kadungathukundu Town, Kalpakanchery",
              "addressRegion": "Kerala",
              "postalCode": "676551",
              "addressCountry": "IN"
            }
          }
        `}</script>
      </Helmet>
      <div className="text-center text-2xl pt-10 border-t">
        <Title text1={"CONTACT"} text2={"US"} />
      </div>
      <div className="my-10 flex flex-col justify-center md:flex-row gap-10 mb-28">
        <img
          className="w-full md:max-w-[480px]"
          src={assets.contact_img}
          alt=""
        />
        <div className="flex flex-col justify-center items-start gap-6">
          <p className="font-semibold text-xl text-gray-600">Our Store</p>
          <p className=" text-gray-500">
            Mambara Rd, Kadungathukundu Town, <br /> Kalpakanchery, <br />{" "}
            Kerala 676551
          </p>
          <p className="text-gray-500">
            Phone Number : +91 98958 46494 <br /> Email: about@sccstore.com
          </p>

          <p className="font-semibold text-xl text-gray-600">Connect With Us</p>
          <p className="text-gray-600">
            Follow us on <a href="https://www.instagram.com/sahlacurtaincenter/" target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">Instagram</a>, <a href="https://www.facebook.com/people/Sahla-Curtain-Center/61565451845405/" target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">Facebook</a>, and <a href="https://www.youtube.com/@sahlacurtaincenter" target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">YouTube</a> for updates, offers, and more.
          </p>
          <p className="text-gray-600">
            For business inquiries, collaborations, or feedback, please email <a href="mailto:about@sccstore.com" className="text-blue-600 underline">about@sccstore.com</a> or call us directly.
          </p>

          <p className="font-semibold text-xl text-gray-600">
            Careers at Sahla Curtain Center
          </p>
          <p className="text-gray-600">
            Learn more about our teams and job openings
          </p>
          <button className="border border-black px-8 py-4 text-sm hover:bg-black hover:text-white transition-all duration-500">
            Explore More
          </button>
        </div>
      </div>

      <div className="my-10 flex flex-col justify-center md:flex-row gap-10 mb-28">
        <p className="font-semibold text-xl text-gray-600">Shop Services Availability</p><br />
        <div className="text-gray-500">
          We provide services on Saturday 9 am–9 pm <br />
          We do not provide services on Sunday 9 am–9 pm <br />
          We provide services on Monday 9 am–9 pm <br />
          We provide services on Tuesday 9 am–9 pm <br />
          We provide services on Wednesday 9 am–9 pm <br />
          We provide services on Thursday 9 am–9 pm <br />
          We provide services on Friday 9 am–9 pm
        </div>
      </div>
      <NewsletterBox />
    </div>
  );
};

export default Contact;
